export default "__VITE_ASSET__DchAxwrP__"